import { Component, OnInit,Input } from '@angular/core';

export interface SimpleOption {
  id: string;
  name: string;
}

@Component({
  selector: 'DocGenLib',
  template: `
  <div>
  <cmpts-card [data]="data"></cmpts-card>  
  </div>  
  `,
  styleUrls: []
})
export class TextBoxComponentsLibComponent implements OnInit {
@Input() data:any={};
  constructor() { 
  }

  ngOnInit(): void {    
  }

}
